import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's own scale: unknown `text-h1` reads as a text colour and
 * gets deleted when a real colour follows. Teach it our scale, radii and shadows (index.css).
 */
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			text: ['display', 'h1', 'h2', 'h3', 'lead', 'body', 'small', 'micro'],
			radius: ['input', 'btn', 'card', 'dialog', 'band'],
			shadow: ['1', '2', '3', 'sheet'],
		},
	},
})

/** Merge Tailwind classes so a caller's `className` always wins over a default. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
